export enum PropertyCategoryEnum {
  MultiStoryResidential = "multi_story_residential",
  MultiStoryOffice = "multi_story_office",
  RetailFbAndEntertainment = "retail_f_b_and_entertainment",
  VillaHouse = "villa_house",
  IndustryWorkshopWarehouse = "industry_workshop_warehouse",
}